<div class="card-body p-0">
  <div class="mat-elevation-z8" style="border: 1px solid rgba(0, 0, 0, 0.12); border-top: none">
    <table style="width: 100%" mat-table matSort [dataSource]="dataSource">
      <tr mat-header-row *matHeaderRowDef="displayedColumnsChildInstallments"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsChildInstallments;"></tr>
      <ng-container matColumnDef="next-payment">
        <th mat-header-cell *matHeaderCellDef>{{ "PAYMENTS.payment-schedule" | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <div *ngIf="element.active">
            <span>{{ element.term_date | toDateObject | date }}</span>
            <p class="m-0" style="color: red"
               *ngIf="element.amount_paid < element.amount && (element.term_date | toDateObject) < now">
              <small>{{ "PAYMENTS.missed_payment" | translate }}</small>
            </p>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="date-paid">
        <th mat-header-cell
            *matHeaderCellDef>{{ "DISTRIBUTION.installments.dist_date_paid" | translate }}
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.date_paid | toDateObject | date }}
          <ng-container *ngIf="element.date_paid">
            <p class="m-0" style="color: green" *ngIf="element.amount_paid === element.amount">
              <small>{{ "PAYMENTS.paid" | translate }}</small>
            </p>
            <p class="m-0" style="color: orange"
               *ngIf="element.amount_paid < element.amount && element.amount_paid > 0">
              <small>{{ "PAYMENTS.partial-paid" | translate }}</small>
            </p>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>{{ "PAYMENTS.amount" | translate }}</th>
        <td mat-cell *matCellDef="let childElement">
          <small class="font-weight-lighter">{{ +childElement.amount_paid | number: '1.2-2' }}€
            / {{ +childElement.amount | number: '1.2-2' }}€ </small>
          <span
            class="fw-bold">- {{ +(childElement.amount) - +(childElement.amount_paid) | number: '1.2-2' }}
            €</span>
          <div class="progress" style="max-width: 120px">
            <div class="progress-bar progress-bar-striped" role="progressbar"
                 [style]="{width: getPercent(childElement?.amount_paid, childElement?.amount)  + '%'}"
                 [attr.aria-valuenow]="getPercent(childElement?.amount_paid, childElement?.amount)"
                 [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">{{
                getPercent(childElement?.amount_paid,
                  childElement?.amount)
              }}%
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "PAYMENTS.label" | translate }}</th>
        <td mat-cell *matCellDef="let element">
          {{ element.case_payment_plan?.type?.name }}<br>
          {{ element.parent_installment.name }}
        </td>
      </ng-container>
    </table>

    <div *ngIf="isLoading" class="text-center" style="padding: 50px">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div
      *ngIf="!isLoading && dataSource && dataSource.data.length < 1"
      style="padding: 50px">
      <h5 class="text-center">{{ "PAYMENTS.no-payments" | translate }}</h5>
    </div>
    <mat-paginator
      [length]="paginatorConfig.length"
      [pageSize]="paginatorConfig.pageSize"
      [pageSizeOptions]="[5, 10, 20, 25]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
